<flx-modal-panel headerClass="justify-between">
  <ng-container header>
    <div class="flex gap-1 justify-center items-center">
      @if (showTabs()) {
        <div class="ml-1 h-full border-b-2 border-blue-500 text-blue-500 text-xs p-3 font-semibold">
          JS
        </div>
      }
      @if (showLangSelect()) {
        <flx-select
          [disabled]="aiReadonly() || readonly()"
          [hasClear]="false"
          [(ngModel)]="language"
          class="flx-ds small"
        >
          @for (language of languages; track $index) {
            <flx-select-option
              [value]="language"
              class="text-xs"
            >
              {{ language.label }}
            </flx-select-option>
          }
        </flx-select>
      }
      @if (supportsGraalVM()) {
        <flx-select
          [disabled]="aiReadonly() || readonly()"
          [hasClear]="false"
          [(ngModel)]="useGraalVM"
          class="flx-ds small"
          data-testid="business-rule-runtime-select"
        >
          @for (option of scriptRuntimeOptions; track option.value) {
            <flx-select-option
              [value]="option.value"
              class="text-xs"
            >
              {{ option.label }}
            </flx-select-option>
          }
        </flx-select>
      }
    </div>
    <div class="flex gap-1 py-1 justify-center items-center">
      <!-- TODO: rewire to the AI builder harness
      @if (enableAiActions() && canUseAiActions()) {
        <button
          [disabled]="aiReadonly()"
          (click)="aiMenu.toggle($event)"
          class="flx-ds small ternary"
          data-testid="ai-actions-menu-button"
          icon="center"
          flxButton
        >
          <flx-icon
            name="stars-flowx-yellow"
            class="w-4 h-4"
          />
        </button>
      }
      -->
      <button
        [disabled]="saveButtonDisabled()"
        (click)="onSave()"
        class="flx-ds small secondary"
        data-testid="scripting-edit-save-button"
        flxButton
      >
        {{ saveButtonLabel() }}
      </button>
      <button
        [disabled]="!canTestExpression() && aiReadonly()"
        (click)="onRun()"
        class="flx-ds small"
        flxButton
      >
        <flx-icon name="play" />
        <span class="line-clamp-1 w-max">Test</span>
      </button>
    </div>
  </ng-container>
  @if (showPreviewArea()) {
    @if (previewMode() === 'simple') {
      <flx-ai-preview-area
        [ignorePadding]="true"
        title="Generated Code"
        class="h-full"
      >
        <flx-code-editor
          [readonly]="true"
          [autocompleteOptions]="autocompleteOptions()"
          [autocompleteEnabled]="true"
          [options]="codeEditorOptions()"
          [ngModel]="aiGeneratedScript()"
          class="h-full"
        ></flx-code-editor>
      </flx-ai-preview-area>
    } @else {
      @if (agentProcessingMessage() || aiConversationStreaming()) {
        <flx-ai-preview-area
          [ignorePadding]="true"
          title="Generated Code"
          class="h-full"
        >
          <flx-code-editor
            [readonly]="true"
            [autocompleteOptions]="autocompleteOptions()"
            [options]="codeEditorPreviewOptions"
            [ngModel]="aiGeneratedScript()"
            class="h-full"
          ></flx-code-editor>
        </flx-ai-preview-area>

        @if (showAiLoader()) {
          <div class="absolute top-0 left-0 w-full h-full flex justify-center items-center">
            <div
              class="flex flex-col gap-y-6 items-center justify-center w-64 h-64 bg-white rounded-3xl shadow-xl cursor-auto"
            >
              <flx-ai-loader
                [white]="false"
                [title]="'Generating code...'"
              ></flx-ai-loader>
            </div>
          </div>
        }
      } @else {
        <div class="relative w-full h-full">
          <flx-monaco-diff-editor
            [options]="diffEditorOptions()"
            [originalModel]="diffOriginalModel()"
            [modifiedModel]="diffModifiedModel()"
            (layoutChange)="onDiffLayoutChange($event)"
            class="h-full"
          ></flx-monaco-diff-editor>

          <flx-ai-preview-area
            [ignorePadding]="true"
            [style.left.px]="originalEditorWidth()"
            [style.width]="previewAreaWidth()"
            title="Generated Code"
            class="absolute top-0 h-full pointer-events-none transparent"
          >
          </flx-ai-preview-area>
        </div>
      }
    }
  }

  <flx-code-editor
    [class.hidden]="showPreviewArea()"
    [readonly]="aiReadonly() || readonly()"
    [autocompleteOptions]="autocompleteOptions()"
    [autocompleteEnabled]="true"
    [canReferenceFunctions]="canReferenceFunctions()"
    [options]="codeEditorOptions()"
    [selectionWidget]="aiSelectionWidget()"
    (errorsChange)="onErrorsChange($event)"
    (selectionChange)="onCodeEditorSelectionChange($event)"
    (scrollChange)="onCodeEditorScroll()"
    [(ngModel)]="code"
    class="h-full"
    data-testid="scripting-edit-code-editor"
  ></flx-code-editor>
</flx-modal-panel>

<!-- TODO: rewire to the AI builder harness
<p-menu
  #aiMenu
  [popup]="true"
  [model]="aiActionsOptions()"
  styleClass="font-semibold flx-prime-menu"
  appendTo="body"
/>
-->

<div [hidden]="true">
  <flx-ai-code-selection
    #editorSelectionWidget
    [selection]="this.codeEditorSelection()"
    [contextType]="contextType()"
    [conversationTargetDescriptor]="conversationTargetDescriptor()"
  />
</div>
